import * as dateFns from 'date-fns'
import * as React from 'react'
import { IHolidayItem } from '../../../types/index'

interface IServiceViewHolidaysProps {
  holidaysList: { [key: string]: IHolidayItem }
}

const ServiceViewHolidays = (props: IServiceViewHolidaysProps) => {
  return (
    <React.Fragment>
      {Object.values(props.holidaysList).map(it => (
        <ServiceViewHolidayItem key={`holiday-${it.id}`} holidayItem={it} />
      ))}
    </React.Fragment>
  )
}

const ServiceViewHolidayItem = ({ holidayItem }: { holidayItem: IHolidayItem }) => (
  <div className='mt3'>
    {/*Labels*/}
    <div className='flex flex-row'>
      <div className='col-2 h5 font-dark-grey'>Date of Exception</div>
      <div className='col-2 ml2 h5 font-dark-grey'>From</div>
      <div className='col-2 ml2 h5 font-dark-grey'>Until</div>
    </div>

    {/*Input fields*/}
    <div className='flex flex-row items-center mt1'>
      <div className='col-2'>{!!holidayItem.date && dateFns.format(holidayItem.date, 'MM/DD/YYYY')}</div>
      <div className='col-2 ml2'>{holidayItem.from}</div>
      <div className='col-2 ml2'>{holidayItem.until}</div>
    </div>
  </div>
)

export default ServiceViewHolidays



// WEBPACK FOOTER //
// ./src/components/services/view/ServiceViewHolidays.tsx